import jwt from 'jwt-decode'

export function memberProfileFromResponse(responseData) {
  if (responseData?.user && typeof responseData.user === 'object') {
    return responseData.user
  }
  if (responseData?.token) {
    return jwt(responseData.token)
  }
  return null
}


// Share the pending bootstrap across StrictMode mounts and simultaneous consumers.
let pendingSession = null;
export function loadSession(client, host, token) {
  if (pendingSession?.token === token) return pendingSession.promise;
  const promise = Promise.all([
    client.post(`${host}/user`, { jwt_token: token }, { timeout: 15000 }),
    client.post(`${host}/organization`, { jwt_token: token }, { timeout: 15000 }),
  ]).then(([user, organization]) => ({
    token: user.data.token || token,
    member: memberProfileFromResponse(user.data),
    organization: organization.data.organization,
  }));
  pendingSession = { token, promise };
  const clear = () => { if (pendingSession?.promise === promise) pendingSession = null; };
  promise.then(clear, clear);
  return promise;
}

export const isInvalidSession = error => error?.response?.status === 401;
